import React from 'react';
import { TableViewComponent } from '../../../../ui-components/data-viz-ui/table/TableViewComponent';
import { TimePeriodSegmentedTableViewUiComponentProps } from './types';

export const TimePeriodSegmentedBarChartUiComponent = (
  props: TimePeriodSegmentedTableViewUiComponentProps
) => {
  return <TableViewComponent {...props} />;
};
